<template>
    <div>
        <Card>
            <Tabs value="curSale"
                :animated="false">
                <TabPane label="现售送货单质检"
                    name="curSale">
                    <transition name="fade">
                        <Row v-if="curSaleMainTable.sarchCardShow"
                            :gutter="16">
                            <Col span="24">
                            <search-card :form="curSaleMainTable.searchForm"
                                :table-load-event="getCurSaleDistributionStationStoreTableRecords"
                                :table-search="curSaleMainTable.tableSearch" />
                            </Col>
                        </Row>
                    </transition>

                    <Row :gutter="16">
                        <Col span="24">
                        <div class="global-tool-bar">
                            <div class="left-bar">
                                <span class="title" />
                            </div>
                            <div class="right-bar">
                                <Button type="primary"
                                    size="small"
                                    class="btns"
                                    shape="circle"
                                    icon="ios-search"
                                    @click="curSaleMainTable.sarchCardShow = !curSaleMainTable.sarchCardShow">搜索</Button>
                            </div>
                        </div>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <stand-pagination-table :columns="curSaleMainTable.columns"
                            :data="curSaleMainTable.data"
                            :extHeight="60"
                            :loading="curSaleMainTable.loading"
                            :table-search="curSaleMainTable.tableSearch"
                            :table-load-event="getCurSaleDistributionStationStoreTableRecords" />
                        </Col>
                    </Row>
                </TabPane>
                <TabPane label="预售送货单质检"
                    name="preSale">
                    <transition name="fade">
                        <Row v-if="preSaleMainTable.sarchCardShow"
                            :gutter="16">
                            <Col span="24">
                            <search-card :form="preSaleMainTable.searchForm"
                                :table-load-event="getPreSaleDistributionStationStoreTableRecords"
                                :table-search="preSaleMainTable.tableSearch" />
                            </Col>
                        </Row>
                    </transition>

                    <Row :gutter="16">
                        <Col span="24">
                        <div class="global-tool-bar">
                            <div class="left-bar">
                                <span class="title" />
                            </div>
                            <div class="right-bar">
                                <Button type="primary"
                                    size="small"
                                    class="btns"
                                    shape="circle"
                                    icon="ios-search"
                                    @click="preSaleMainTable.sarchCardShow = !preSaleMainTable.sarchCardShow">搜索</Button>
                            </div>
                        </div>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <stand-pagination-table :columns="preSaleMainTable.columns"
                            :data="preSaleMainTable.data"
                            :extHeight="60"
                            :loading="preSaleMainTable.loading"
                            :table-search="preSaleMainTable.tableSearch"
                            :table-load-event="getPreSaleDistributionStationStoreTableRecords" />
                        </Col>
                    </Row>
                </TabPane>

            </Tabs>
        </Card>

        <PreDistributionStationDeliveryCheckEdit ref="preDistributionStationDeliveryCheckEditModal" />
        <CurDistributionStationDeliveryCheckEdit ref="curDistributionStationDeliveryCheckEditModal" />
        <PreDistributionStationDeliveryEdit ref="preDistributionStationDeliveryEditModal" />
        <CurSaleDistributionStationDeliveryEdit ref="curSaleDistributionStationDeliveryEditModal" />
    </div>
</template>

<script>
import search from '@/libs/search';
import SearchCard from '@/components/searchCard/searchCard';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import {
    CHECK_STATUS_TYPE_PARTIAL_PASSED,
    CHECK_STATUS_TYPE_PASSED,
    CHECK_STATUS_TYPE_UN_CHECK
} from '@/view/distributionStation-management/distributionStation-delivery-check/DistributionStationDeliveryCheckType';

import {
    getDistributionStationCurSaleDeliveryCheckList,
    getDistributionStationPreSaleDeliveryCheckList
} from '@/api/modules/distributionStation-management/distributionStation-product-store';

import PreDistributionStationDeliveryCheckEdit from './preSale-distributionStation-delivery-check-edit';
import CurDistributionStationDeliveryCheckEdit from './curSale-distributionStation-delivery-check-edit';
import PreDistributionStationDeliveryEdit from './../distributionStation-delivery/preSale-distributionStation-delivery-edit';
import CurSaleDistributionStationDeliveryEdit from './../distributionStation-delivery/curSale-distributionStation-delivery-edit';

export default {
    name: 'DistributionStationDeliveryCheck',
    components: {
        StandPaginationTable,
        SearchCard,
        PreDistributionStationDeliveryCheckEdit,
        CurDistributionStationDeliveryCheckEdit,
        PreDistributionStationDeliveryEdit,
        CurSaleDistributionStationDeliveryEdit
    },
    data() {
        return {
            distributionStationUuid: '',
            preSaleMainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '发货单号', key: 'preSaleDeliveryRecordCode', align: 'center', width: 160 },
                    { title: '关联销售单', key: 'preSaleOrderRecordCode', align: 'center', width: 150 },
                    { title: '会员账号', key: 'CustomerName', align: 'center', width: 80 },
                    { title: '会员名称', key: 'customerPersonName', align: 'center', width: 80 },
                    {
                        title: '质检状态', key: 'preSaleDeliveryRecordDistributionStationCheckStatus', align: 'center', width: 100,
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.checkStatusOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onCheckStatusOrderChange();
                                            }
                                        }

                                    })
                                ]
                            );
                        }
                    },
                    {
                        title: '转运站状态', key: 'preSaleDeliveryRecordPaidStatus', align: 'center', width: 100,
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.deliveryOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onDeliveryChange();
                                            }
                                        }

                                    })
                                ]
                            );
                        },
                        render: (h, params) => {
                            let text = params.row.preSaleDeliveryRecordPaidStatus === '未支付' ? '未发货' : '已发货';
                            return h('div', [
                                h('span', {
                                }, text)
                            ]);
                        }
                    },
                    { title: '送货总量', key: 'preSaleDeliveryRecordTotalQuantity', align: 'center', width: 80 },
                    { title: '苗场', key: 'seedFarmName', align: 'center', width: 100 },
                    { title: '送货单制单人', key: 'userPersonName', align: 'center', width: 80 },
                    { title: '送货日期', key: 'preSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate), width: 100 },
                    { title: '物流公司', key: 'preSaleDeliveryRecordLogisticsCompanyName', width: 80, align: 'center' },
                    { title: '制单时间', key: 'preSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.preSaleDeliveryRecordCreateAt), width: 150 },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        fixed: 'right',
                        width: 100,
                        render: (h, params) => {
                            const text = params.row.preSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK ? '质检' : '查看';

                            const btns = [];
                            const checkBtnElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.preDistributionStationDeliveryCheckEditModal.showModal(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, text);
                            btns.push(checkBtnElement);

                            //预售定单，转运站发货是才扣款，这个利用支付状态来标识转运站是否已发货
                            if (params.row.preSaleDeliveryRecordDistributionStationCheckStatus !== CHECK_STATUS_TYPE_UN_CHECK && params.row.preSaleDeliveryRecordPaidStatus === '未支付') {
                                const deliveryBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.preDistributionStationDeliveryEditModal.showModal(params.row.preSaleDeliveryRecordRelateOrderRecordUuid, params.row.preSaleDeliveryRecordUuid, params.row.preSaleDeliveryRecordSeedFarmUuid);
                                        }
                                    }
                                }, '发货');
                                btns.push(deliveryBtn);
                            }

                            return h('div', btns);
                        }
                    }

                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '送货单号', type: 'Input', value: '', name: 'preSaleDeliveryRecordCode', sql: 'like' },
                    { label: '关联销售单', type: 'Input', value: '', name: 'preSaleOrderRecordCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(customer.userName,customer.userPersonName)', sql: 'like' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            curSaleMainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '发货单号', key: 'curSaleDeliveryRecordCode', align: 'center', width: 170 },
                    { title: '关联销售单', key: 'curSaleOrderRecordCode', align: 'center', width: 150 },
                    { title: '会员账号', key: 'CustomerName', align: 'center', width: 60 },
                    { title: '会员名称', key: 'customerPersonName', align: 'center', width: 80 },
                    {
                        title: '质检状态', key: 'curSaleDeliveryRecordDistributionStationCheckStatus', align: 'center', width: 100,
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.checkStatusOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onCheckStatusOrderChange();
                                            }
                                        }

                                    })
                                ]
                            );
                        }
                    },
                    {
                        title: '转运站状态', key: 'unDeliveryCount', align: 'center', width: 100,
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.deliveryOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onDeliveryChange();
                                            }
                                        }

                                    })
                                ]
                            );
                        },
                        render: (h, params) => {
                            let text = params.row.unDeliveryCount > 0 ? '未发货' : '已发货';
                            return h('div', [
                                h('span', {
                                }, text)
                            ]);
                        }
                    },
                    { title: '送货总量', key: 'curSaleDeliveryRecordTotalQuantity', align: 'center', width: 80 },
                    { title: '苗场', key: 'seedFarmName', align: 'center', width: 100 },
                    { title: '送货单制单人', key: 'userPersonName', align: 'center', width: 80 },
                    { title: '送货日期', key: 'curSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleDeliveryRecordDeliveryDate), width: 100 },
                    { title: '物流公司', key: 'curSaleDeliveryRecordLogisticsCompanyName', width: 80, align: 'center' },
                    { title: '制单时间', key: 'curSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.curSaleDeliveryRecordCreateAt), width: 150 },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        fixed: 'right',
                        width: 100,
                        render: (h, params) => {
                            const text = params.row.curSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK ? '质检' : '查看';

                            const btns = [];
                            const checkBtnElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.curDistributionStationDeliveryCheckEditModal.showModal(params.row.curSaleDeliveryRecordUuid);
                                    }
                                }
                            }, text);
                            btns.push(checkBtnElement);

                            if (params.row.curSaleDeliveryRecordDistributionStationCheckStatus !== CHECK_STATUS_TYPE_UN_CHECK && params.row.unDeliveryCount > 0) {
                                const deliveryBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.curSaleDistributionStationDeliveryEditModal.showModal(params.row.curSaleDeliveryRecordRelateOrderRecordUuid, params.row.curSaleDeliveryRecordSeedFarmUuid, params.row.curSaleDeliveryRecordUuid);
                                        }
                                    }
                                }, '发货');
                                btns.push(deliveryBtn);
                            }
                            return h('div', btns);
                        }
                    }

                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '送货单号', type: 'Input', value: '', name: 'curSaleDeliveryRecordCode', sql: 'like' },
                    { label: '关联销售单', type: 'Input', value: '', name: 'curSaleOrderRecordCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(customer.userName,customer.userPersonName)', sql: 'like' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            checkStatusOrder: 0,
            deliveryOrder: 0
        };
    },
    props: {
        userType: { type: String, default: '' }
    },
    mounted() {
        this.init();
    },
    computed: {
        checkStatusOrderIcon() {
            if (this.checkStatusOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.checkStatusOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        deliveryOrderIcon() {
            if (this.deliveryOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.deliveryOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        }
    },
    methods: {
        init() {
            this.getPreSaleDistributionStationStoreTableRecords();
            this.getCurSaleDistributionStationStoreTableRecords();
        },
        onDeliveryChange() {
            this.deliveryOrder = (this.deliveryOrder + 1) % 3;
            this.init();
        },
        onCheckStatusOrderChange() {
            this.checkStatusOrder = (this.checkStatusOrder + 1) % 3;
            this.init();
        },
        setCurSaleOrderCondition() {
            this.curSaleMainTable.tableSearch.order.enable = false;
            this.curSaleMainTable.tableSearch.order.conditions = [];

            if (this.checkStatusOrder == 1) {
                this.curSaleMainTable.tableSearch.order.conditions.push({
                    name: "curSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "asc"
                });
                this.curSaleMainTable.tableSearch.order.enable = true;
            }
            else if (this.checkStatusOrder == 2) {
                this.curSaleMainTable.tableSearch.order.conditions.push({
                    name: "curSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "desc"
                });
                this.curSaleMainTable.tableSearch.order.enable = true;
            }

            if (this.deliveryOrder == 1) {
                this.curSaleMainTable.tableSearch.order.conditions.push({
                    name: "unDeliveryCount",
                    type: "asc"
                });
                this.curSaleMainTable.tableSearch.order.enable = true;
            }
            else if (this.deliveryOrder == 2) {
                this.curSaleMainTable.tableSearch.order.conditions.push({
                    name: "unDeliveryCount",
                    type: "desc"
                });
                this.curSaleMainTable.tableSearch.order.enable = true;
            }
        },
        setPreSaleOrderCondition() {
            this.preSaleMainTable.tableSearch.order.enable = false;
            this.preSaleMainTable.tableSearch.order.conditions = [];

            if (this.checkStatusOrder == 1) {
                this.preSaleMainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "asc"
                });
                this.preSaleMainTable.tableSearch.order.enable = true;
            }
            else if (this.checkStatusOrder == 2) {
                this.preSaleMainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "desc"
                });
                this.preSaleMainTable.tableSearch.order.enable = true;
            }

            if (this.deliveryOrder == 1) {
                this.preSaleMainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordPaidStatus",
                    type: "asc"
                });
                this.preSaleMainTable.tableSearch.order.enable = true;
            }
            else if (this.deliveryOrder == 2) {
                this.preSaleMainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordPaidStatus",
                    type: "desc"
                });
                this.preSaleMainTable.tableSearch.order.enable = true;
            }
        },
        getPreSaleDistributionStationStoreTableRecords(reset = false) {
            this.preSaleMainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.preSaleMainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.preSaleMainTable.tableSearch, "customer.userType");
                this.preSaleMainTable.tableSearch.filters.enable = true;
                this.preSaleMainTable.tableSearch.filters.conditions.push({
                    name: 'customer.userType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.setPreSaleOrderCondition();
            getDistributionStationPreSaleDeliveryCheckList(this.preSaleMainTable.tableSearch).then(res => {
                this.preSaleMainTable.loading = false;
                if (res.code === 0) {
                    this.preSaleMainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.preSaleMainTable.tableSearch, res.data.filterRecordCount);
                }
            }).catch(() => {
                this.preSaleMainTable.loading = false;
            });
        },
        getCurSaleDistributionStationStoreTableRecords() {

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.curSaleMainTable.tableSearch, "customer.userType");
                this.curSaleMainTable.tableSearch.filters.enable = true;
                this.curSaleMainTable.tableSearch.filters.conditions.push({
                    name: 'customer.userType',
                    type: 'eq',
                    value: this.userType
                });
            }

            this.setCurSaleOrderCondition();
            this.curSaleMainTable.loading = true;
            getDistributionStationCurSaleDeliveryCheckList(this.curSaleMainTable.tableSearch).then(res => {
                this.curSaleMainTable.loading = false;
                if (res.code === 0) {
                    this.curSaleMainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.curSaleMainTable.tableSearch, res.data.filterRecordCount);
                }
            }).catch(() => {
                this.curSaleMainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
